import { trackMatomoEvent } from '@/lib/matomo-events'

export const SITE_SEARCH_MIN_LENGTH = 2

type SiteSearchInput = {
  q: string
  resultsCount: number
  tagId?: number
  locationIds?: number[]
  date?: string
  range?: string
}

export type SiteSearchPayload = {
  keyword: string
  category: string | false
  resultsCount: number
}

export function isSiteSearchQuery(q: string | null | undefined): boolean {
  return (q ?? '').trim().length >= SITE_SEARCH_MIN_LENGTH
}

export function buildSiteSearchPayload(input: SiteSearchInput): SiteSearchPayload {
  const parts: string[] = []
  if (input.tagId !== undefined) parts.push(`tag:${input.tagId}`)
  if (input.locationIds && input.locationIds.length > 0) {
    parts.push(`loc:${[...input.locationIds].sort((a, b) => a - b).join(',')}`)
  }
  if (input.range) parts.push(`range:${input.range}`)
  else if (input.date) parts.push(`date:${input.date}`)

  return {
    keyword: input.q.trim().toLowerCase(),
    category: parts.length > 0 ? parts.join('|') : false,
    resultsCount: input.resultsCount,
  }
}

let lastKey: string | null = null

export function resetSiteSearchDedup() {
  lastKey = null
}

export function trackSiteSearch(payload: SiteSearchPayload): boolean {
  if (typeof window === 'undefined') return false

  const key = JSON.stringify(payload)
  if (key === lastKey) return false
  lastKey = key

  window._paq = window._paq || []
  window._paq.push(['setCustomUrl', `${window.location.pathname}${window.location.search}`])
  window._paq.push(['trackSiteSearch', payload.keyword, payload.category, payload.resultsCount])
  return true
}

export function trackSearchResultClick(keyword: string, position: number) {
  trackMatomoEvent('Site Search', 'result_click', keyword, position)
}
